import { PlusOutlined } from "@ant-design/icons"
import { Button, Typography } from "antd"
import React from "react"
import { Link } from "react-router-dom"

import type { QuickAction } from "./_helpers.ts"

interface QuickActionsSectionProps {
  title: string
  actions: QuickAction[]
  labelFor: (action: QuickAction) => string
}

export const QuickActionsSection = ({
  title,
  actions,
  labelFor
}: QuickActionsSectionProps) => {
  if (!actions.length) return null

  return (
    <section data-testid={"mobile-home-actions"}>
      <Typography.Title level={5} className={"!mb-2"}>
        {title}
      </Typography.Title>
      <div className={"flex flex-wrap gap-2"}>
        {actions.map((action) => (
          <Link
            key={action.key}
            to={action.to}
            className={"flex-1 min-w-[45%]"}
          >
            <Button type={"primary"} icon={<PlusOutlined />} block>
              {labelFor(action)}
            </Button>
          </Link>
        ))}
      </div>
    </section>
  )
}
